var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgButtonswiper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 27,
    r: 27,
    fill: "#F75524"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 25.2679C37.3333 26.0377 37.3333 27.9623 36 28.7321L24 35.6603C22.6667 36.4301 21 35.4678 21 33.9282L21 20.0718C21 18.5322 22.6667 17.5699 24 18.3397L36 25.2679Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonswiper);
export default __webpack_public_path__ + "static/media/buttonswiper.cc65a720528926fb6b57917ad59d31a4.svg";
export { ForwardRef as ReactComponent };